import React from 'react'
import { ActivityCard, ActivityCardItem } from '../../../Common/DesignSystem/ActivityCard'
import Skeleton from 'react-loading-skeleton'
import colours from '../../../Common/DesignSystem/Colours'
import { P4 } from '../../../Common/DesignSystem/Text'

const UtilizationCard = ({ type, utilizationData, ...props }) => {


  const openVehicleDetails = (vehicle) => {
    const { path } = props.match
    const { id, sourceVehicleId } = vehicle;
    props.history.push(`${path}/vehicle/${sourceVehicleId}/Overview/${id}`);
  }

  return (
    <ActivityCard
      noShadow
      iconContainerStyle={{ borderRadius: '8px', color: type === 'lowest' ? colours.accent.error_red : colours.accent.validate_green, backgroundColor: type === 'lowest' ? colours.functional.hover_secondaryred : colours.functional.hover_secondarygreen }}
      label={type === "lowest" ? "Lowest Utilization" : "Highest Utilization"}
      iconName={type === "lowest" ? "UtilizationLow" : "UtilizationHigh"}
      activityCards={[
        <ActivityCardItem key={type + "_utilization_card_item"}
          headerComponent={
            <div style={{ height: 100, minWidth: 226, width: '100%' }}>
              {utilizationData ?
                utilizationData.map((item, index) => {
                  return (
                    <div className='ds-dashboard-util-line-item' key={index}>
                      <div className="hover-ul" onClick={() => openVehicleDetails(item.vehicle)}>
                        <P4 style={{ textAlign: 'start' }}>{item.vehicle.displayName || <Skeleton />}</P4>
                      </div>
                      <div className='ds-dashboard-util-line-item-right'>
                        <div className='ds-dashboard-util-line-bg'>
                          <div style={{ width: Math.round(item.utilization * 40), borderRadius: 8, backgroundColor: type === 'lowest' ? colours.accent.error_red : colours.accent.validate_green, height: 4 }}></div>
                        </div>
                        <P4>{Math.round(item.utilization * 100)}%</P4>
                      </div>
                    </div>
                  )
                })
                : <Skeleton count={5} />}
            </div>
          }
        />
      ]}
    />
  )
}

export default UtilizationCard